<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             @cancel="closeDialog"
             @ok="onConfirm"
  >
    <template #title>
      {{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}
    </template>
    <template #body>
      <div class="d-flex flex-column row-gap-2">
        <p>{{ $t(`${TRANSLATION_KEY_PREFIX}.message.${tab}`) }}</p>
        <p>{{ $t(`${TRANSLATION_KEY_PREFIX}.confirmation`) }}</p>
      </div>
    </template>
    <template #footer>
      <div class="d-flex column-gap-4 justify-content-end">
        <app-button type="outlined" variant="neutral"  @click="closeDialog">
          {{ $t("common.cancel") }}
        </app-button>
        <app-button variant="danger" @click="onConfirm">
          {{ $t(`${TRANSLATION_KEY_PREFIX}.confirmButtonLabel`) }}
        </app-button>
      </div>
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

const TRANSLATION_KEY_PREFIX = 'project.checklist.dialogs.ChecklistPaneDataUnsavedDialog'

export default {
  name: 'ChecklistPaneDataUnsavedDialog',
  emits: ['close', 'confirm'],
  mixins: [dialogMixin],
  props: {
    tab: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
